import {
  Box,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import ReadMore from "../ReadMore";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import { translator } from "../../utils/translations/translator";
import { eventCategoriesAr } from "../../utils/translations";

type IProps = {
  handleClick: any;
  row: any;

  handleOpenDelete: any;
  handleEdit: any;
};

const classes = {
  between: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontWeight: "bold",
  },
  category: {
    fontWeight: "bold",
  },
};

const ListItem: React.FC<IProps> = ({
  handleClick,
  row,

  handleOpenDelete,
  handleEdit,
}) => {
  const { isRTL } = useRTL();
  const { general } = useContent();

  return (
    <Card>
      <CardActionArea onClick={() => handleClick(row.id)}>
        <CardContent sx={{ pt: 1, pr: 1 }}>
          <Box sx={classes.between}>
            <Typography
              variant="h5"
              component="h5"
              color="primary"
              sx={classes.title}
            >
              {row.title}
            </Typography>
            <CardActions disableSpacing sx={{ p: 0 }}>
              <Tooltip title={general.edit}>
                <IconButton
                  onClick={(e: any) => {
                    e.stopPropagation();
                    handleEdit(row.id);
                  }}
                >
                  <EditIcon color="primary" />
                </IconButton>
              </Tooltip>
              <Tooltip title={general.delete}>
                <IconButton
                  onClick={(e: any) => {
                    e.stopPropagation();
                    handleOpenDelete(row);
                  }}
                >
                  <DeleteIcon color="error" />
                </IconButton>
              </Tooltip>
            </CardActions>
          </Box>
          <Typography variant="body1" component="p" sx={classes.category}>
            {isRTL ? translator(row.category, eventCategoriesAr) : row.category}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            <ReadMore text={row.details} />
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ListItem;
